import { useParams } from "react-router-dom"
import { useGetVisitorListQuery } from "../../features/CallApi"
import { useEffect } from "react"
import { Button, Container } from "reactstrap"
import { VisitorStatus } from "./VisitorStatus"
import LoadScreen from "../UI/LoadScreen"
import { format, set } from "date-fns"
import { useState } from "react"
import { HttpTransportType, HubConnectionBuilder } from "@microsoft/signalr";
import useToken from "../useToken"
import { ButtonNewStatus } from "./ButtonNewStatus"
import { VisitorCounter } from "./VisitorСounter"
import Countdown, { zeroPad } from 'react-countdown';
import { Gear } from "react-bootstrap-icons"
import { EditVisitor } from "./EditVisitor"
import { Col, FloatingLabel, Form, Row } from "react-bootstrap"



export const EventList = () => {

    const { id } = useParams()
    const [connection, setConnection] = useState(null);
    const { token, role } = useToken();
    const [stringFilter, setStringFilter] = useState("");
    const [filters, setFilters] = useState("");
    const [items, setItems] = useState();
    const { data, refetch } = useGetVisitorListQuery({ id, stringFilter })
    const [visitorId, setVisitorId] = useState();
    const [modal, setModal] = useState(false);
    const [selStatus, setSelStatus] = useState()

    useEffect(() => {
        refetch()
        const newConnection = new HubConnectionBuilder()
            .withUrl("/visitorlisthub", {
                headers: {
                    Authorization: "Bearer " + token,
                },
                transport: HttpTransportType.LongPolling
            })
            .withAutomaticReconnect()
            .build()
        setConnection(newConnection)
    }, [])

    useEffect(() => {
        if (connection) {
            connection.on("ReceiveMessage", (sessionId) => {
                if (sessionId == id) {
                    refetch();
                }
            });
            connection.on("ReceiveForceUpdate", (sessionId) => {
                console.log(sessionId)
                if (sessionId == id) {
                    refetch();
                }
            });
            connection.start().then(() => {
                console.log("Connected!");
            });
            return () => connection.stop();
        }

    }, [connection]);

    const sendMessage = (id, status, sessionId, cabin) => {
        if (window.confirm(`Изменить статус?`)) {
            connection.invoke("SendMessage", id, status, parseInt(sessionId), cabin).catch((err) => console.error(err))
        }
    }

    const forceUpdate = (id) => {
        connection.invoke("ForceUpdate", id).catch((err) => { console.error(err) })
    }

    useEffect(() => {
        if (data) {
            if (filters) {
                const filterData = data.visitorsLists
                    .filter((item) =>
                        item.name.toLocaleLowerCase().includes(filters.toLocaleLowerCase()) ||
                        item.comment?.toLocaleLowerCase().includes(filters.toLocaleLowerCase()) ||
                        item.commentLine2?.toLocaleLowerCase().includes(filters.toLocaleLowerCase()) ||
                        item.order?.toLocaleLowerCase().includes(filters.toLocaleLowerCase()) ||
                        item.numberOfList.toString().includes(filters.toLocaleLowerCase()))
                setItems(filterData)
            }
            else {
                if (selStatus) {
                    const filterData = data.visitorsLists.filter((item) => item.visitorStatus === parseInt(selStatus))
                    setItems(filterData)
                }
                else {
                    setItems(data.visitorsLists)
                }
            }
        }
    }, [data, filters, selStatus])

    const renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <span>Результат готов</span>
        } else {
            // Render a countdown
            return <span>{zeroPad(minutes)}:{zeroPad(seconds)}</span>;
        }
    };

    const editVisitor = (id) => {
        setModal(!modal)
        setVisitorId(id)
    }

    return (
        <div>
            {/* <button onClick={() => playSound()}>Play sound</button> */}
            {data ?
                <Container>
                    <EditVisitor id={visitorId} modal={modal} setModal={setModal} token={token} eventType={data.sessionEvent.typeOfEvent} forceUpdate={forceUpdate} />

                    <h3>Список <strong>{data.sessionEvent.title}</strong></h3>
                    <h5>Дата мероприятия: {format(new Date(data.sessionEvent.dateEvent), 'dd.MM.yyyy')}</h5>
                    <VisitorCounter eventType={data.sessionEvent.typeOfEvent} visitors={data.visitorsLists} />

                    <div className="sticky-top">
                        <Row>
                            <Col md={'auto'}>
                                <FloatingLabel className="mb-1 mt-1" controlId="floatingSelectStatus" label="Фильтр по статусу">
                                    <Form.Select onChange={(e) => setSelStatus(e.target.value)} aria-label="Фильтр по статусу">
                                        <option value={""}>--- не выбран ---</option>
                                        <option value={0}>Ожидаем</option>
                                        <option value={1}>На месте</option>
                                        <option value={2}>Сдал тест</option>
                                        <option value={3}>Вход разрешен</option>
                                        <option value={4}>Вход запрещен</option>
                                        <option value={5}>Заказ выдан</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Col>
                            <Col>
                                <FloatingLabel
                                    // controlId="stringFilter"
                                    label="Поиск..."
                                    className="mb-1 mt-1"
                                >
                                    <Form.Control type={`text`} id="stringFilter" placeholder="Поиск..." onChange={
                                        (e) => setTimeout(() => { setFilters(e.target.value) }, 500)} />
                                </FloatingLabel>
                                {/* <input type={`text`} id="stringFilter" onChange={
                                    (e) => setTimeout(() => { setFilters(e.target.value) }, 500)}
                                    placeholder="Поиск.." name="stringFilter" className="form-control mt-3" /> */}
                            </Col>
                        </Row>
                    </div>
                    <div className="table-responsive" style={{minHeight: "50vh"}}>
                        <table style={{ fontSize: "14px" }} className="table table-hover ">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    {(data.sessionEvent.typeOfEvent === 3 || data.sessionEvent.typeOfEvent === 5) && <th>Заказ</th>}
                                    {(data.sessionEvent.typeOfEvent === 3 || data.sessionEvent.typeOfEvent === 5) && <th>Ряд(Место)</th>}
                                    {(data.sessionEvent.typeOfEvent !== 3 && data.sessionEvent.typeOfEvent !== 5) && <th>Ф.И.О.</th>}
                                    {(data.sessionEvent.typeOfEvent === 3 || data.sessionEvent.typeOfEvent === 5) &&
                                        <th>
                                            Ф.И.О. | Комментарий
                                        </th>
                                    }
                                    {(data.sessionEvent.typeOfEvent !== 3 && data.sessionEvent.typeOfEvent !== 5) && <th>Комментарий</th>}
                                    {(data.sessionEvent.typeOfEvent === 4 || data.sessionEvent.typeOfEvent == 6) && <th>Кабинка</th>}
                                    {data.sessionEvent.typeOfEvent === 1 && <th>Таймер</th>}
                                    <th>Статус</th>
                                    <th></th>
                                </tr>
                            </thead>

                            {items && items.length > 0 ?
                                <tbody>
                                    {items.map(visitor =>
                                        <tr key={visitor.id}>
                                            <td style={{ verticalAlign: "middle" }} className="text-nowrap">
                                                {role == "Admins" &&
                                                    <Button onClick={() => editVisitor(visitor.id)} className="me-2" outline size="sm">
                                                        <Gear size="12" />
                                                    </Button>
                                                }
                                                {visitor.numberOfList}</td>
                                            {(data.sessionEvent.typeOfEvent === 3 || data.sessionEvent.typeOfEvent === 5) &&
                                                <td style={{ verticalAlign: "middle" }}>{visitor.order}</td>
                                            }
                                            {(data.sessionEvent.typeOfEvent !== 3 && data.sessionEvent.typeOfEvent !== 5) &&
                                                <>
                                                    <td style={{ verticalAlign: "middle" }}>{visitor.name}</td>
                                                    <td>{visitor.comment}</td>
                                                </>
                                            }
                                            {(data.sessionEvent.typeOfEvent === 3 || data.sessionEvent.typeOfEvent === 5) &&
                                                <>
                                                    <td>{visitor.comment}</td>
                                                    <td style={{ verticalAlign: "middle" }}>
                                                        <div>{visitor.name}</div>
                                                        {visitor.commentLine2 &&
                                                            <div className="border-top">
                                                                {visitor.commentLine2}
                                                            </div>
                                                        }
                                                    </td>
                                                </>
                                            }
                                            {(data.sessionEvent.typeOfEvent === 4 || data.sessionEvent.typeOfEvent === 6) &&
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <div className="text-nowrap">
                                                        {visitor.order}
                                                    </div>

                                                    <div>
                                                        {visitor.visitorStatus === 2 &&
                                                            <strong> <Countdown renderer={renderer} date={visitor.testReadinessTime} /></strong>
                                                        }
                                                    </div>
                                                </td>
                                            }
                                            {data.sessionEvent.typeOfEvent === 1 &&
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <div>
                                                        {visitor.visitorStatus === 2 &&
                                                            <strong> <Countdown renderer={renderer} date={visitor.testReadinessTime} /></strong>
                                                        }
                                                    </div>
                                                </td>
                                            }
                                            <td style={{ verticalAlign: "middle" }}>
                                                <VisitorStatus status={visitor.visitorStatus} />
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <ButtonNewStatus
                                                    id={visitor.id}
                                                    eventType={data.sessionEvent.typeOfEvent}
                                                    status={visitor.visitorStatus}
                                                    sendMessage={sendMessage}
                                                    sessionId={data.sessionEvent.id} />

                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                :
                                <tbody>
                                    <tr><td colSpan={5} className="text-center">Список пуст</td></tr>
                                </tbody>
                            }
                        </table>
                    </div>
                </Container>
                : <LoadScreen />}
        </div >
    )

}